export const US_COUNTRY_CODE = '1';
export const MIN_PHONE_LENGTH = 10;
export const FORMAT = '(###) ###-####';
export const MASK = '_';
export const ALLOW_EMPTY_FORMATTING = false;
export const ERROR_CODE_NOT_SUPPORTED = 'NOT_SUPPORTED';
